"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "expandTargetDefinition", {
    enumerable: true,
    get: function() {
        return expandTargetDefinition;
    }
});
function expandTargetDefinition(packageName, task, pipeline, outputs) {
    const id = packageName ? `${packageName}#${task}` : task;
    const emptyDefinition = {
        cache: false,
        dependsOn: [],
        options: {},
        outputs
    };
    const definition = id in pipeline ? pipeline[id] : `#${task}` in pipeline ? pipeline[`#${task}`] : `//${task}` in pipeline ? pipeline[`//${task}`] : task in pipeline ? pipeline[task] : emptyDefinition;
    if (Array.isArray(definition)) {
        return emptyDefinition;
    } else {
        return definition;
    }
}
